import React from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import sleeveWithLogoImage from 'assets/img/sleeve-with-logo.jpg';
import classes from './discount-info-dialog.scss';
function DiscountInfoDialog(props) {
  const {
    open,
    onRequestClose
  } = props;
  return /*#__PURE__*/React.createElement(ControlDialog, {
    content: /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h2", null, "Preview of Swag.com logo on sleeve"), /*#__PURE__*/React.createElement("img", {
      alt: "sleeve with logo",
      src: sleeveWithLogoImage,
      className: classes.image
    })),
    onRequestClose: onRequestClose,
    open: open
  });
}
export default DiscountInfoDialog;